import Accordion from '@components/Accordion';
import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import usePriceUnit from '@hooks/item/usePriceUnit';
import { GiftItemRow } from '@models/gift';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

interface Props {
    giftItem: GiftItemRow;
    qty: number;
}

function ItemInfo({ giftItem, qty }:Props) {
    const { name, imageUrl, salePrice } = giftItem;
    const { t } = useTranslation('gift');
    const priceUnit = usePriceUnit();
    return (
        <div className={styles.wrapper}>
            <Accordion title={t('giftOrder.giftProduct')}
                initialOpen
                className={styles.accordion}
                handleClassName={styles.accordionHandle}
                titleClassName={styles.title}>
                <Row className={styles.contents}
                    spacing={16}
                    align='flex-start' >
                    <div className={styles.image}>
                        <Image src={imageUrl}
                            width={72}
                            height={72}
                            alt=''/>
                    </div>
                    <Column>
                        <Text size='lg' fontWeight='bold' color={colors.gray6}>
                            {name}
                        </Text>
                        <Row spacing={8}>
                            <Text color={colors.gray8}>{t('giftOrder.quantity', { qty })}</Text>
                            <div className={styles.dot} />
                            <Text color={colors.gray8}>{(salePrice * qty).toLocaleString()}{priceUnit}</Text>
                        </Row>
                    </Column>
                </Row>
            </Accordion>
        </div>
    );
}

export default ItemInfo;
